import type { ReactNode } from 'react';
import { ButtonIcon, Text } from '@backstage/ui';
import {
  RiCloseLine,
  RiContractLeftRightLine,
  RiExpandLeftRightLine,
  RiSparkling2Line,
} from '@remixicon/react';
import { useChatDrawer } from '../../drawerApi';
import styles from './ChatDrawer.module.css';

/** Title bar of the drawer; `children` are the actions of the current view. */
export const DrawerHeader = ({ children }: { children?: ReactNode }) => {
  const { expanded, api } = useChatDrawer();

  return (
    <div className={styles.header}>
      <span className={styles.brand} aria-hidden="true">
        <RiSparkling2Line size={18} />
      </span>
      <Text variant="body-medium" className={styles.title}>
        AI Chat
      </Text>
      {children}
      <ButtonIcon
        variant="tertiary"
        size="small"
        className={styles.expand}
        icon={
          expanded ? <RiContractLeftRightLine /> : <RiExpandLeftRightLine />
        }
        aria-label={expanded ? 'Narrow the chat' : 'Widen the chat'}
        onClick={() => api.setExpanded(!expanded)}
      />
      <ButtonIcon
        variant="tertiary"
        size="small"
        icon={<RiCloseLine />}
        aria-label="Close chat"
        onClick={() => api.close()}
      />
    </div>
  );
};
